<template>
<el-row v-if="!hidePage">
    <el-col :span="12" v-if="remarks" class="yl-page-remark">
        {{remarks}}
    </el-col>
    <el-col :span="remarks ? 12 : 24" v-if="total>0">
        <el-pagination align="right" 
            :layout="hideTotal? 'prev,pager,next' : 'total,prev,pager,next,sizes'"
            :page-size="pageRow"
            :total= total
            :page-sizes="[20, 50, 100]"
            :current-page.sync="page"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        >
        </el-pagination>
    </el-col>
</el-row>
</template>
<script>
export default {
    name:"yl-lc-page",
    // 账户中心账单查询中信不返回总条数，hideTotal隐藏total和jumper
    props: {
        hidePage: {
            type: Boolean,
            default:false
        },
        hideTotal: {
            type: Boolean,
            default:false
        },
        remarks:{
            type: String,
            default:''
        }
    },
	data(){
        return {
            total:20,
            page:1,
            pageRow: 20
        }
	},
    watch:{
        "$router.query.page":{
            handler(newValue,oldValue){
                this.pageCurrent = newValue;
                this.$set(this,'pageCurrent',newValue)
            },
            immediate: true,
            deep: true
        }
    },
	mounted(){
	},
    methods: {
        handleSizeChange(val) {
            this.$nextTick(function(){
                this.page = 1;
                this.pageRow = val;
                this.$emit('sizeChange');
            });
        },
        handleCurrentChange(val) {
            this.$nextTick(function(){
                this.page = val;
                this.$emit('currentChange');
            });
        },
    }
}
</script>
<style lang="less" scope>
.yl-page-remark{
    word-wrap: break-word;
}
</style>
